import React from "react";
import styles from "./styles.module.scss";
import { IconButton, Stack, Typography } from "@mui/material";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const CustomCalendarHeader = (props) => {
  const { currentMonth, onMonthChange, onViewChange, views, view } = props;
  const selectNextMonth = () => onMonthChange(currentMonth.add(1, "month"));
  const selectPreviousMonth = () =>
    onMonthChange(currentMonth.subtract(1, "month"));
  const toggleYears = () => onViewChange(views.find(el => el !== view));

  return (
    <div className={styles["custom-calendar-header"]}>
      <Stack spacing={1} direction="row">
        <IconButton onClick={selectPreviousMonth} title="Previous month">
          <ChevronLeft />
        </IconButton>
      </Stack>
      <Typography variant="body2">{currentMonth.format("MMMM")}</Typography>
      <Stack spacing={1} direction="row">
        <IconButton onClick={selectNextMonth} title="Next month">
          <ChevronRight />
        </IconButton>
      </Stack>
      <Typography variant="body2">{currentMonth.format("YYYY")}</Typography>
      <Stack spacing={1} direction="row">
        <IconButton onClick={toggleYears} title="Next year">
          {view === 'year' ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </IconButton>
      </Stack>
    </div>
  );
};

export default CustomCalendarHeader;
